<header class="ob-review__head">
	<p class="ob-review__eyebrow">{{ 'merit.onboarding.review.eyebrow' | transloco }}</p>
	<h2 class="ob-review__title">{{ 'merit.onboarding.review.title' | transloco }}</h2>
	<p class="ob-review__lede">{{ 'merit.onboarding.review.lede' | transloco }}</p>
</header>

<div class="ob-review__sections">
	@for (section of sections(); track section.step) {
		<section class="qs-card ob-review__card">
			<header class="qs-head ob-review__cardhead">
				<span class="ob-index">{{ pad(section.number) }}</span>
				<div class="qs-headings">
					<h3 class="qs-title">{{ 'merit.onboarding.steps.' + section.step + '.title' | transloco }}</h3>
					<p class="qs-hint">
						@if (section.done) {
							<span class="ob-review__done">
								<lucide-icon name="Check" [size]="13"></lucide-icon>
								{{ 'merit.onboarding.review.done' | transloco }}
							</span>
						} @else {
							<span class="ob-review__pending">{{ 'merit.onboarding.review.pending' | transloco }}</span>
						}
					</p>
				</div>
				<button type="button" class="ob-review__edit" (click)="edit.emit(section.number - 1)">
					<lucide-icon name="Pencil" [size]="14"></lucide-icon>
					{{ 'merit.onboarding.review.edit' | transloco }}
				</button>
			</header>

			@if (section.empty) {
				<p class="ob-review__empty">{{ 'merit.onboarding.review.emptySection' | transloco }}</p>
			}

			@if (section.rows.length) {
				<dl class="ob-review__rows">
					@for (row of section.rows; track row.label) {
						<div class="ob-review__row">
							<dt>{{ row.label | transloco }}</dt>
							<dd>{{ row.value }}</dd>
						</div>
					}
				</dl>
			}

			@if (section.items.length) {
				<ul class="ob-review__items">
					@for (item of section.items; track $index) {
						<li>
							<span class="ob-review__itemtitle">{{ item.title }}</span>
							<span class="ob-review__itemdetail">{{ item.detail }}</span>
						</li>
					}
				</ul>
			}

			@for (file of section.files; track file.id) {
				<a class="ob-review__file" [href]="file.publicUrl" target="_blank" rel="noopener">
					<lucide-icon name="Paperclip" [size]="14"></lucide-icon>
					<span>{{ file.originalName }}</span>
					@if (file.durationSeconds) {
						<span class="ob-review__filemeta">{{ file.durationSeconds }} s</span>
					}
				</a>
			}
		</section>
	}
</div>

@if (!state().canSubmit && blockingReasons().length) {
	<div class="ob-review__blocked" role="alert">
		<p class="ob-review__blockedtitle">
			<lucide-icon name="TriangleAlert" [size]="16"></lucide-icon>
			{{ 'merit.onboarding.review.blockedTitle' | transloco }}
		</p>
		<ul>
			@for (reason of blockingReasons(); track $index) {
				<li>{{ reason }}</li>
			}
		</ul>
	</div>
}

@if (error(); as message) {
	<p class="qs-alert" role="alert">
		<i class="pi pi-exclamation-circle" aria-hidden="true"></i>
		<span>{{ message }}</span>
	</p>
}

<div class="qs-actionbar">
	<span class="qs-actionbar__note">{{ 'merit.onboarding.review.note' | transloco }}</span>
	<div class="qs-actionbar__buttons">
		<button type="button" class="qs-btn qs-btn--ghost" (click)="edit.emit(lastScreen)">
			{{ 'merit.onboarding.actions.back' | transloco }}
		</button>
		<button
			type="button"
			class="qs-btn qs-btn--primary"
			[disabled]="!state().canSubmit || submitting()"
			(click)="send.emit()"
		>
			{{ (submitting() ? 'merit.onboarding.actions.submitting' : 'merit.onboarding.actions.submit') | transloco }}
		</button>
	</div>
</div>
